import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import SortAscIcon from '@material-ui/icons/ArrowDownward'
import SortDescIcon from '@material-ui/icons/ArrowUpward'


import PaperBlock from "../../ui/PaperBlock"

/**
 * <ControlPanel
 * 	order - undefined, ASC, DESC
 * 	onSrotByDateClick = {order}
 * />
 */

class ControlPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Сортировка по дате"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSrotByDateClick === "function") {
							this.props.onSrotByDateClick(this.props.order)
						}
					}}
				>
					{
						(order => {
							switch (order) {
								case 'ASC':
									return <SortAscIcon />
								case 'DESC':
									return <SortDescIcon />
								default:
									return <SortAscIcon
										color = 'disabled'
									/>
							}
						})(this.props.order)
					}
				</Button>
			</div></Tooltip>

		</PaperBlock>

	}

}

export default ControlPanel
